import { Package } from '@features/DynamicPackagesConfigurationWizard/types';
import { TranslationKey } from '@lang';

export type PackageInclusion = 'room' | 'spa' | 'dining';

export const packageExtraInclusions: PackageInclusion[] = ['spa', 'dining'];

export const inclusionLabelKeys: Record<PackageInclusion, TranslationKey> = {
  room: 'common.room',
  spa: 'common.spa',
  dining: 'common.dining',
};

export type PackageExperience = NonNullable<Package['experiences']>[number];
type PackageExperienceOption = NonNullable<PackageExperience['options']>[number];

export const isSpaExtra = (option: PackageExperienceOption) => option.itemType === 'spa-extras';

export const isSpaTreatment = (option: PackageExperienceOption) =>
  option.itemType === 'spa-treatments';

export const isSpaExperience = (experience: PackageExperience) =>
  !!experience.options?.some((option) => !isSpaExtra(option));

const hasSpaExperience = (packageData: Package) => !!packageData.experiences?.some(isSpaExperience);

export const getRateInclusions = (packageData?: Package | null): PackageInclusion[] => {
  const inclusions: PackageInclusion[] = ['room'];

  if (!packageData) return inclusions;

  if (hasSpaExperience(packageData)) inclusions.push('spa');
  if (packageData.restaurants?.length) inclusions.push('dining');

  return inclusions;
};

export const getPackageInclusions = (packageData?: Package | null): PackageInclusion[] =>
  getRateInclusions(packageData).filter((inclusion) => packageExtraInclusions.includes(inclusion));
